<template>
	<div class="region">
		<div class="container">
			<div class="history block" v-if="historyWords.length>0">
				<h3>
					<b>历史</b>
					<van-icon name="delete" @click="delHistory"/>
				</h3>
				<div>
					<span v-for="(item,index) in historyWords" :key="index"  @click="clickKeyWord(item.id,item.name)">{{item.name}}</span>
				</div>	
			</div>
			<div class="block">
				<h3>常见城市索引</h3>
				<div>
					<span v-for="(item,index) in hotCitys" :key="index" @click="clickKeyWord(item.id,item.name)">{{item.name}}</span>
				</div>	
			</div>
			<div class="area">
				<van-tabs v-model="active" color="#fff" title-active-color="#901d22" title-inactive-color="#bdbdbd">
				  <van-tab title="国内">
					<div class="block">
						<div>
							<span v-for="(item,index) in provinces" :key="index" @click="clickKeyWord(item.id,item.name)" c>{{item.name}}</span>
						</div>	
					</div>				  	
				  </van-tab>
				  <van-tab title="港澳台及国际">
					<div class="block">
						<div>
							<span v-for="(item,index) in special" :key="index" @click="clickKeyWord(item.id,item.name)" >{{item.name}}</span>
						</div>	
					</div>					  	
				  </van-tab>
				</van-tabs>
			</div>	
		</div>
	</div>
</template>
<script>
	import {MeetingRegions,searchMeetingPlace} from '../../config/interface.js'
	export default{
		props:{
			historyWords:Array
		},
		data(){
			return{
				active:0,
				hotCitys:[],
				provinces:[],
				special:[]
			}
		},
		mounted(){
			this.init('common');
			this.init('province');
			this.init('special');
		},
		methods:{
			//初始化
			init(keywords){
				const url=MeetingRegions;
				const method='POST';
				let params={
					keywords:keywords
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						switch(keywords){
							case 'common':
								this.hotCitys=data;
								break;
							case 'province':
								this.provinces=data;
								break;
							case 'special':
								this.special=data;
								break;
						}
						
					}
				})
			},
			clickKeyWord(id,name){
				
				this.$emit('goSearch',{name:name,id:id})
			},
			//清除搜索历史
			delHistory(){
				this.$emit('clearHistory')
			}
		}
	}
</script>
<style lang="scss">
	.region{
		.history{
			h3{
				@include flex(row);
				justify-content:space-between;
				i{
					font-size:21px;
				}
			}
		}
		.block{
			padding:0 12px;
			h3{
				font-size: 15px;
				color: #090909;
				letter-spacing: 0.6px;
				margin:15px 0;
			}
			>div{
				display:flex;
				flex-wrap: wrap;
			}
			span{
				font-size:13px;
				color:#090909;
				display:-webkit-box;
				padding:0 1%;
				width:20%;
				height:30px;
				line-height:30px;
				overflow:hidden;
				-ms-text-overflow:ellipsis;
				text-overflow:ellipsis;
				-webkit-box-orient:vertical;
				-webkit-line-clamp:1;
				text-align:center;
				box-sizing:border-box;
				border: 1px solid #D3D3D3;
				border-radius: 2px;
				margin-right:6%;
				margin-bottom:13px;
			}
			span:nth-child(4n){
				margin-right:0px;
			}

		}
		.area{
			.van-tabs--line .van-tabs__wrap{
				border:0px;
			}
			.van-tabs__nav{
				padding-left:12px;
			}
			.van-tab:first-child{
				flex:initial;
				width:20%;
			}
			.van-tab{
				text-align:left;
				font-size:17px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Meeting/Region.vue